function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M30.71 7.29l-6-6A1 1 0 0024 1H4a3 3 0 00-3 3v24a3 3 0 003 3h24a3 3 0 003-3V8a1 1 0 00-.29-.71zM20 3v6h-8V3h8zM8 29v-7a1 1 0 011-1h14a1 1 0 011 1v7H8zm21-1a1 1 0 01-1 1h-2v-7a3 3 0 00-3-3H9a3 3 0 00-3 3v7H4a1 1 0 01-1-1V4a1 1 0 011-1h6v6a2 2 0 002 2h8a2 2 0 002-2V3h1.59L29 8.41V28z",
  fill: "currentColor"
});

function SvgIconSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgPHBhdGggZD0iTTMwLjcxIDcuMjlsLTYtNkExIDEgMCAwMDI0IDFINGEzIDMgMCAwMC0zIDN2MjRhMyAzIDAgMDAzIDNoMjRhMyAzIDAgMDAzLTNWOGExIDEgMCAwMC0uMjktLjcxek0yMCAzdjZoLThWM2g4ek04IDI5di03YTEgMSAwIDAxMS0xaDE0YTEgMSAwIDAxMSAxdjdIOHptMjEtMWExIDEgMCAwMS0xIDFoLTJ2LTdhMyAzIDAgMDAtMy0zSDlhMyAzIDAgMDAtMyAzdjdINGExIDEgMCAwMS0xLTFWNGExIDEgMCAwMTEtMWg2djZhMiAyIDAgMDAyIDJoOGEyIDIgMCAwMDItMlYzaDEuNTlMMjkgOC40MVYyOHoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgIconSave as ReactComponent };